import * as React from 'react';
import { ContentPanel } from '@enginuity-apps-ui-components/atoms/content-panel/content-panel';
import { Button } from '@enginuity-apps-ui-components/atoms/button/button';

export type IGenericErrorMessage = {
  errorMsg?: string;
  tryAgainLink?: string;
  fromUri: string;
};

export default function GenericErrorMessage({ errorMsg, tryAgainLink, fromUri }: IGenericErrorMessage) {
  return (
    <div className="container  ">
      <div className="row md-spacer-80 spacer-32">
        <div className="col-lg-8 offset-lg-2">
          <ContentPanel>
            <div className="generic-error-message-panel message-panel__padding">
              <div className="row spacer-16">
                <div className="col-12">
                  <h4>One of our systems did not respond as expected</h4>
                </div>
              </div>
              <div className="row spacer-80">
                <div className="col-12">
                  <p>Creating your account failed</p>
                  {errorMsg && <p>The following error code was returned</p>}
                </div>
              </div>
              <div className="row spacer-32">
                <div className="col-12">
                  <p>{errorMsg && (errorMsg as any).toString()}</p>
                </div>
              </div>
              <div className="row spacer-32">
                <div className="col-12">
                  <Button buttonType="link" href={tryAgainLink ?? `/signin?fromURI=${fromUri}`} className="cmp-button--secondary">Try again</Button>
                </div>
              </div>
              <div className="row spacer-80">
                <div className="col-12">
                </div>
              </div>
            </div>
          </ContentPanel>
        </div>
      </div>
    </div >
  );
}
